import { ComponentRoute } from '@/classes'

const DashboardRoutes = {
  DashboardView: new ComponentRoute('/', 'DashboardView')
}

export default DashboardRoutes
